// extracted by mini-css-extract-plugin
export default {"wrapper":"TabTable3_wrapper__uaaF0","container":"TabTable3_container__8ddp9","tabHolder":"TabTable3_tabHolder__aiW8n"};